import { CurrentUserInfo } from "../shared/types/UserManagement";
import { call } from "../tsrpc";

const CACHE_KEY = "editor.currentUser";

let memoryCache: { token: string; user: CurrentUserInfo } | undefined;
let pendingRequest: Promise<CurrentUserInfo> | undefined;

/** 返回与当前 Token 匹配的登录用户缓存。 */
export function getCachedCurrentUser(): CurrentUserInfo | undefined {
  const token = localStorage.getItem("token");
  if (!token) return undefined;
  if (memoryCache?.token === token) return memoryCache.user;

  try {
    const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || "null");
    if (cached?.token === token && cached?.user?._id) {
      memoryCache = cached;
      return cached.user as CurrentUserInfo;
    }
  } catch {
    localStorage.removeItem(CACHE_KEY);
  }
  return undefined;
}

/** 从服务端读取当前用户，并按当前 Token 缓存身份信息。 */
export async function loadCurrentUser(force = false): Promise<CurrentUserInfo> {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("未登录");

  const cached = getCachedCurrentUser();
  if (!force && cached) return cached;
  if (pendingRequest) return pendingRequest;

  pendingRequest = (async () => {
    const response = await call("editor/GetCurrentUser", {
      timestamp: Date.now(),
      token,
    });
    if (!response.isSucc) throw new Error(response.err.message);

    memoryCache = { token, user: response.res.data };
    localStorage.setItem(CACHE_KEY, JSON.stringify(memoryCache));
    return response.res.data;
  })();

  try {
    return await pendingRequest;
  } finally {
    pendingRequest = undefined;
  }
}

/** 清除本地保存的管理后台身份信息。 */
export function clearCurrentUserCache(): void {
  memoryCache = undefined;
  pendingRequest = undefined;
  localStorage.removeItem(CACHE_KEY);
}
